var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.slider && _vm.slider.value
    ? _c(
        "div",
        { staticClass: "v-range-slider" },
        [
          _c("div", { staticClass: "v-range-slider__top" }, [
            _c("div", { staticClass: "v-range-slider__label" }, [
              _c("span", [_vm._v("от")]),
              _vm._v(" "),
              _c("input", {
                attrs: { readonly: "", type: "text" },
                domProps: { value: _vm.formatPrice(_vm.slider.value[0]) },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "v-range-slider__label" }, [
              _c("span", [_vm._v("до")]),
              _vm._v(" "),
              _c("input", {
                attrs: { readonly: "", type: "text" },
                domProps: { value: _vm.formatPrice(_vm.slider.value[1]) },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("VueSlider", {
            attrs: {
              min: _vm.slider.min,
              max: _vm.slider.max,
              minRange: _vm.slider.minRange,
              maxRange: _vm.slider.maxRange,
              interval: 1000,
            },
            on: { change: _vm.change },
            model: {
              value: _vm.slider.value,
              callback: function ($$v) {
                _vm.$set(_vm.slider, "value", $$v)
              },
              expression: "slider.value",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }